export { default as PartInfo } from "./PartInfo.vue";